import PropTypes from 'prop-types';
import React from 'react';
import {Row, Col} from 'react-bootstrap';
import intlC from '../../constants/intl';
import CR from '../../constants/routes';
import {connect} from 'react-redux';
import { bindActionCreators } from 'redux';
import styled from 'styled-components';
import {withRouter} from 'react-router-dom';
import Style from './style.scss';
import CA from '../../constants/analytics';
import * as AnalyticsAction from '../../actions/analytics';

const StyledLink = styled.a`    
    color: ${props => props.theme.brandColor};
    
    &:hover {
        color: ${props => props.theme.brandColor};
    }
`;

class Breadcrumbs extends React.Component {

    goHome(e) {
        e.preventDefault();
        this.props.analyticActions.reportAnalytics([CA.BREADCRUMBS_HOME, CA.CLICK, this.props.location.pathname]);
        this.props.history.push(CR.ROOT_PATH);
    }

    render() {
        return (
            <Row>
                <Col lg={11} lgOffset={1}>
                    <StyledLink href='' onClick={this.goHome.bind(this)} className={Style.link} >&lt; {this.props.intlObject['ssp.breadcrumbs.home']}</StyledLink>
                </Col>
            </Row>
        )
    }
}

Breadcrumbs.propTypes = {
    intlObject: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    analyticActions: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    return {
        intlObject: state.intl.get(intlC.INTL_OBJECT)
    }
}
function mapDispatchToProps(dispatch) {
    return {
        analyticActions: bindActionCreators(AnalyticsAction, dispatch)
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Breadcrumbs));


// WEBPACK FOOTER //
// ./components/Breadcrumbs/index.js